var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('l-map',{ref:"map",attrs:{"zoom":_vm.zoom,"center":_vm.center}},[_c('l-tile-layer',{attrs:{"url":_vm.url}}),_vm._v(" "),(!_vm.isCircle)?_c('l-polygon',{attrs:{"latLngs":_vm.latlngs}}):_vm._e(),_vm._v(" "),_c('l-marker',{attrs:{"lat-lng":_vm.marker}},[_c('l-popup',{attrs:{"content":_vm.popup}})],1),_vm._v(" "),(_vm.isCircle)?_c('l-circle',{attrs:{"lat-lng":_vm.coordinates,"radius":_vm.radius}}):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a84dec0e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BaseMap.vue
// module id = 1573
// module chunks = 0 1